import { FeatureName } from '../../type/core';
import { UserGroupPermissionId } from './UserGroupPermissionId';
/**
 * Identifies if a permission requires specific any of the required court system
 * features. No entry means the permission is not feature specific
 */
export const PERMISSIONS_BY_COURT_SYSTEM_FEATURE = {
    [UserGroupPermissionId.AccessReports]: [FeatureName.AudioOrdering, FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.AdministerBillingGroups]: [FeatureName.AudioOrdering, FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.AdministerHolidays]: [FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.ProcessTranscriptOrders]: [FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.ProcessAudioOrders]: [FeatureName.AudioOrdering],
    [UserGroupPermissionId.ProcessRealTimeOrders]: [FeatureName.RealTimeOrdering],
    [UserGroupPermissionId.TranscribeRecordings]: [FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.TranscriberReadStt]: [FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.TranscriberReadLogSheets]: [FeatureName.TranscriptOrdering],
    [UserGroupPermissionId.ReadStt]: [FeatureName.AudioPlayback],
    [UserGroupPermissionId.PlaybackRecordings]: [FeatureName.AudioPlayback],
    [UserGroupPermissionId.ReadLogSheets]: [FeatureName.AudioPlayback],
    [UserGroupPermissionId.ShareRecordings]: [FeatureName.AudioPlayback, FeatureName.SharingRecordings],
    [UserGroupPermissionId.DownloadBundles]: [FeatureName.AudioPlayback, FeatureName.BundleDownloads],
    [UserGroupPermissionId.SealContent]: [FeatureName.AudioPlayback],
    [UserGroupPermissionId.ManageWhenCourtroomIsOnTheRecord]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.AccessOffTheRecordContent]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.ManagePastSessions]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.ViewRealTimeRecorders]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.ManageRealtimeRecorders]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.AdvancedRealtimeRecorderConfiguration]: [FeatureName.RealTimeRecorders],
    [UserGroupPermissionId.ModerateProceedings]: [FeatureName.DigitalJustice],
};
